/**
 * Input Schema of CompartilhamentoApp
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {CompartilhamentoApp} from '@/model/resource/CompartilhamentoApp'
import {MotoristaCollection} from '@/model/collection/MotoristaCollection'

/* TODO: review generated schema */
export class InputCompartilhamentoAppSchema extends Schema {
  collectionMotorista = new MotoristaCollection().noPagination()

  readonly name = 'InputCompartilhamentoApp'

  readonly fieldSet: FieldSet<CompartilhamentoApp> = {
    motorista: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionMotorista.all(),
      },
    }),
    qtdCompartilhamento: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'number',
        maxlength: 20,
        step: 1,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
  }
}
